import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/** Optional loading / empty rows for projected list tables. */
@Component({
  selector: 'app-list-module-table-states',
  standalone: true,
  imports: [CommonModule],
  template: `
    <tr *ngIf="loading && !hasRows">
      <td [attr.colspan]="colspan" class="py-12 text-center text-gray-500">{{ loadingLabel }}</td>
    </tr>
    <tr *ngIf="!loading && !hasRows">
      <td [attr.colspan]="colspan" class="py-12 text-center text-gray-500">{{ emptyMessage }}</td>
    </tr>
  `,
})
export class ListModuleTableStatesComponent {
  @Input() loading = false;
  @Input() hasRows = false;
  @Input() colspan = 1;
  @Input() loadingLabel = 'Loading…';
  @Input() emptyMessage = 'No records match your filters.';
}
